'use client';
import { get } from 'lodash';
import dynamic from 'next/dynamic';
import { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import { InputErrorMessage } from './InputErrorMessage';

const Wrapper = styled.div`
    background: #fff;
    margin-bottom: 1rem;

    .ql-editor {
        min-height: 200px;

        strong,
        b {
            font-weight: 600;
        }
    }

    .ql-toolbar,
    .ql-container {
        border-color: ${(props) => props.isInvalid && '#e3342f'};
    }

    .invalid-feedback {
        display: ${(props) => props.isInvalid && 'block'};
    }
`;

export const WYSIWYGInput = ({ name, label, rules = {}, ...props }) => {
    const QuillNoSSRWrapper = useMemo(
        () =>
            dynamic(import('react-quill-new'), {
                ssr: false,
                loading: () => <div />
            }),
        []
    );

    const {
        control,
        formState: { errors }
    } = useFormContext();
    const error = get(errors, name);

    const modules = {
        toolbar: [
            // [{ header: [1, 2, 3, 4, false] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
            // ["link", "image"],
            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            // [{ font: [] }],
            [{ align: [] }],
            ['clean']
        ],
        clipboard: {
            matchVisual: false
        }
    };

    return (
        <Wrapper isInvalid={error} {...props}>
            {label && <label>{label + (rules.required ? ' *' : '')}</label>}
            <Controller
                rules={rules}
                control={control}
                name={name}
                render={({ field: { onChange, onBlur, value } }) => (
                    <QuillNoSSRWrapper
                        theme="snow"
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                        modules={modules}
                    />
                )}
            />
            <InputErrorMessage errors={errors} name={name} />
        </Wrapper>
    );
};
